import React from "react";
import img1 from "../../../assets/img/discover_aeroaegis/6.jpg";
import {
  HiOutlineLightBulb,
  HiOutlineBookOpen,
  HiOutlinePresentationChartLine,
  HiOutlineUserGroup,
} from "react-icons/hi";

export default function MainSection7() {
  return (
    <section className=" pt-5  mb-10">
      <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
        <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
          <div className="relative h-[500px] rounded-3xl overflow-hidden">
            <img
              src={img1}
              alt="Workspace with laptop and plant"
              className="object-cover w-full h-full rounded-3xl"
            />
          </div>

          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
                Thought Leadership: Nurturing Knowledge and Innovation
              </h1>
              <p className="text-lg text-gray-600">
                Contributing to technology and innovation through whitepapers,
                webinars, and insights.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {/* Feature 1 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <HiOutlineLightBulb className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Inspiring Innovation
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Delivering fresh perspectives and creative solutions to
                  industry challenges.
                </p>
              </div>
              {/* Feature 2 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <HiOutlineBookOpen className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Knowledge Sharing
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Disseminating insights via webinars, whitepapers, and case
                  studies.
                </p>
              </div>
              {/* Feature 3 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <HiOutlinePresentationChartLine className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Thoughtful Leadership
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Driving conversations on the future of technology and
                  innovation.
                </p>
              </div>
              {/* Feature 4 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <HiOutlineUserGroup className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Community Engagement
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Connecting with peers to share expertise and foster
                  collaboration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
